import loadable from '@loadable/component';

const RelatedProductsLoader = loadable(() =>
  import(/* webpackChunkName: "secondary-content" */ './related-products')
);

export default RelatedProductsLoader;
